module.exports = __webpack_public_path__ + "static/img/JP.c56a7a23.svg";